import React, { Component, useState, useEffect } from "react"

import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import FloatingLabelInput from "./FloatingLabelInput"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import { Multiselect } from "multiselect-react-dropdown"
import Moment from "moment"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import ReactExport from "react-data-export"
import Select from "react-select"
import InstalmentConditoin from "./InstalmentConditoin"
import Fab from "@material-ui/core/Fab"
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import RequestConcil from "./requestcouncil"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}
const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "blue",
            },
      },
})

class ArchiveOrdersNotPay extends Component {
      cookies = new Cookies()

      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  showPaperDetail: false,
                  archiveDetail: [],
                  arrPriceOffline: [],
                  orderBy: "request_id",
                  order: "desc",
                  options: [],
                  optionInstalmentMode: [],
                  optionFieldInsurance: [],
                  optionCompany: [],
                  optionComoany2: [],
                  optionCity: [],
                  optionState: [],
                  selectedFieldInsurance: [],
                  selectedCompany: [],
                  selectedCity: [],
                  selectedState: [],
                  optionStatus: [],
                  selectedStatus: [],
                  selectedDayEnd: "",
                  selectedDayStart: "",
                  dataChart: [],
                  priceDetail: [],
                  mobileAgentFilter: "",
                  mobileUsertFilter: "",
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getOrder()
                                    console.log("fdsfsdfsdf")
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getOrder() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data }, () => {
                                    self.getoptionInstalmentMode()
                                    self.getFieldInsurance()
                                    self.getCompany()
                                    self.getState()
                                    self.getEmployeeState()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_requestofflinepriced")

            xhttp.open("POST", `${constants.BASE_URL}/employeerequestreport`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeStatusRequest = (request_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.getOrder()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "requestpricedoffline14")
            fd.append("request_id", request_id)
            xhttp.open("POST", `${constants.BASE_URL}/employeerequestreport`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionInstalmentMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_mode_mode_id, label: arr.data[k].instalment_mode_mode_name })
                              }
                              self.setState({ optionInstalmentMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode")
            xhttp.open("POST", `${constants.BASE_URL}organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getFieldInsurance() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var i,
                                    temp,
                                    temparray = []

                              self.setState({ optionFieldInsurance: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/employeerequestreport`)
            xhttp.send(fd)
      }

      getCompany() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Comoany = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Comoany.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionComoany2: Comoany, optionCompany: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getState() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ optionState: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getOptionFilterCity = () => {
            const { selectedState, optionState } = this.state
            this.setState({ optionCity: [] }, () => {
                  for (var i = 0; i < selectedState.length; i++) {
                        this.getCity(selectedState[i].state_id)
                  }
            })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionCity.length > 0) {
                                    var State = self.state.optionCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push(arr.data[k])
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getEmployeeState() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ optionStatus: arr.data })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "getstaterequest")
            xhttp.open("POST", `${constants.BASE_URL}/employeerequestreport`)
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }
      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      getPriceDetail(request) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ arrPriceOffline: arr.data })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_priceoffline")
            fd.append("request_id", request.request_id)
            xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleSelectRows = (request_id, row) => {
            this.setState({ showPaperDetail: false }, () => {
                  this.setState({ showPaperDetail: true, archiveDetail: row }, () => {
                        this.getPriceDetail(row)
                  })
            })
      }

      hidePaperDetail = (event) => {
            this.setState({ showPaperDetail: false })
      }
      onSelectOptionStatus = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedStatus: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionStatus = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedStatus: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCompany: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCompany: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCity: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCity: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedState: selectedList }, () => {
                  this.getOptionFilterCity()
                  this.filterList()
            })
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedState: selectedList }, () => {
                  this.getOptionFilterCity()
                  this.filterList()
            })
      }

      handleChangeFilterMobileAgent = (event) => {
            this.setState({ mobileAgentFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      handleChangeFilterMobileUser = (event) => {
            this.setState({ mobileUsertFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  requestinfos,
                  mobileAgentFilter,
                  mobileUsertFilter,
                  selectedFieldInsurance,
                  selectedCompany,
                  selectedCity,
                  selectedState,
                  selectedStatus,
                  selectedDayEnd,
                  selectedDayStart,
            } = this.state
            var timeStampStart = parseInt(
                  Moment(JDate.toGregorian(selectedDayStart.year, selectedDayStart.month, selectedDayStart.day)).format("x"),
                  0
            )
            var timeStampEnd = parseInt(Moment(JDate.toGregorian(selectedDayEnd.year, selectedDayEnd.month, selectedDayEnd.day)).format("x"), 0)
            var i, temparray, temparray2, staterequest_last_timestamp
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  staterequest_last_timestamp = parseInt(Moment(temparray[i].staterequest_last_timestamp, "YYYY-M-D HH:mm:ss").format("x"))
                  if (
                        this.feieldInsuranceExist(temparray[i].fieldinsurance_id, selectedFieldInsurance) &&
                        this.companyExist(temparray[i].request_company_id, selectedCompany) &&
                        this.cityExist(temparray[i].agent_city_id, selectedCity) &&
                        this.stateExist(temparray[i].agent_state_id, selectedState) &&
                        this.feieldStatusExist(temparray[i].request_last_state_id, selectedStatus) &&
                        ((mobileUsertFilter !== "" && temparray[i].user_mobile.includes(mobileUsertFilter)) || mobileUsertFilter === "") &&
                        (staterequest_last_timestamp > timeStampStart || !timeStampStart) &&
                        (staterequest_last_timestamp < timeStampEnd || !timeStampEnd)
                  ) {
                        if (temparray[i].agent_mobile !== undefined && temparray[i].agent_mobile !== null) {
                              if ((mobileAgentFilter !== "" && temparray[i].agent_mobile.includes(mobileAgentFilter)) || mobileAgentFilter === "") {
                                    temparray2.push(temparray[i])
                              }
                        } else if (mobileAgentFilter === "") {
                              temparray2.push(temparray[i])
                        }
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
            if (selectedFieldInsurance.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedFieldInsurance.length; j++) {
                        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      companyExist = (request_company_id, selectedCompany) => {
            if (selectedCompany.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedCompany.length; j++) {
                        if (request_company_id === selectedCompany[j].company_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      cityExist = (agent_city_id, selectedCity) => {
            if (selectedCity.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedCity.length; j++) {
                        if (agent_city_id === selectedCity[j].city_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      stateExist = (agent_state_id, selectedState) => {
            if (selectedState.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedState.length; j++) {
                        if (agent_state_id === selectedState[j].state_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      feieldStatusExist = (request_state_id, selectedStatus) => {
            if (selectedStatus.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedStatus.length; j++) {
                        if (request_state_id === selectedStatus[j].request_state_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      clearDeyEnd = (event) => {
            this.setState({ selectedDayEnd: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayEnd = (event) => {
            this.setState({ selectedDayEnd: event }, () => {
                  this.filterList()
            })
      }

      clearDeyStart = (event) => {
            this.setState({ selectedDayStart: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayStart = (event) => {
            this.setState({ selectedDayStart: event }, () => {
                  this.filterList()
            })
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.selectedDayEnd.year
                              ? this.state.selectedDayEnd.year + "/" + this.state.selectedDayEnd.month + "/" + this.state.selectedDayEnd.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.selectedDayStart.year
                              ? this.state.selectedDayStart.year + "/" + this.state.selectedDayStart.month + "/" + this.state.selectedDayStart.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )
      render() {
            const { classes } = this.props
            const {
                  arrPriceOffline,
                  optionInstalmentMode,
                  priceDetail,
                  selectedDayEnd,
                  mobileAgentFilter,
                  mobileUsertFilter,
                  selectedDayStart,
                  order,
                  orderBy,
                  archiveDetail,
                  showPaperDetail,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={selectedDayStart}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پایان  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={selectedDayEnd}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionStatus} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionStatus} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionStatus} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionStatus} // Function will trigger on remove event
                                                                              displayValue="request_state_name" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب وضعیت "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionFieldInsurance} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionFieldInsurance} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                                                                              displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب رشته"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionCompany} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                              displayValue="company_name" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب شرکت"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionState} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                              ref={this.multiselectStateRef}
                                                                              displayValue="state_name" // Property name to display in the dropdown options
                                                                              placeholder="استان ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionCity} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionCity} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                              displayValue="city_name" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب شهر"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}></Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="همراه نماینده"
                                                                        value={mobileAgentFilter}
                                                                        handleInputt={this.handleChangeFilterMobileAgent}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="همراه کاربر"
                                                                        value={mobileUsertFilter}
                                                                        handleInputt={this.handleChangeFilterMobileUser}
                                                                  />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}></Grid>

                                    <Grid item xs={12}>
                                          <Collapse in={showPaperDetail}>
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شماره درخواست: " + archiveDetail["request_id"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={8} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"رشته بیمه : " + archiveDetail["request_fieldinsurance_fa"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["fieldinsurance_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شرکت  : " + archiveDetail["company_name"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["company_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"آخرین وضعیت: " + archiveDetail["request_last_state_name"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"تاریخ آخرین وضعیت: "}{" "}
                                                                                    {new JDate(
                                                                                          new Date(
                                                                                                parseInt(
                                                                                                      Moment(
                                                                                                            archiveDetail[
                                                                                                                  "staterequest_last_timestamp"
                                                                                                            ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("x")
                                                                                                )
                                                                                          )
                                                                                    ).format("YYYY/MM/DD ") +
                                                                                          "ساعت " +
                                                                                          Moment(
                                                                                                archiveDetail["staterequest_last_timestamp"],
                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                          ).format("HH:mm")}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"مشخصات کاربر: " +
                                                                                          archiveDetail["user_name"] +
                                                                                          " " +
                                                                                          archiveDetail["user_family"] +
                                                                                          " -  شماره همراه : " +
                                                                                          archiveDetail["user_mobile"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"استان : " +
                                                                                          archiveDetail["agent_state_name"] +
                                                                                          "   - شهرستان:  " +
                                                                                          archiveDetail["agent_city_name"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"جزئیات درخواست: " + archiveDetail["request_description"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Button
                                                                              onClick={() => {
                                                                                    this.changeStatusRequest(archiveDetail["request_id"])
                                                                              }}
                                                                              variant="contained"
                                                                              color="primary"
                                                                        >
                                                                              {" "}
                                                                              تغییر وضعیت درخواست به اتمام نرخ دهی
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        {arrPriceOffline.map((PriceOffline, index) => {
                                                                              return (
                                                                                    <Grid container spacing={3}>
                                                                                          <Grid item xs={12}>
                                                                                                <Divider />
                                                                                          </Grid>
                                                                                          <Grid style={{ backgroundColor: "#cfdfdf" }} item xs={12}>
                                                                                                <PriceCard
                                                                                                      newPriceCard={false}
                                                                                                      PriceOffline={PriceOffline}
                                                                                                      employee_token_str={this.cookies.get(
                                                                                                            "employee_token_str"
                                                                                                      )}
                                                                                                      request={archiveDetail}
                                                                                                      optionInstalmentMode={optionInstalmentMode}
                                                                                                      optionComoany2={this.state.optionComoany2}
                                                                                                />
                                                                                          </Grid>
                                                                                    </Grid>
                                                                              )
                                                                        })}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <PriceCard
                                                                              addPriceCard={() => {
                                                                                    console.log("adasdasda")
                                                                                    this.getPriceDetail(archiveDetail)
                                                                              }}
                                                                              newPriceCard={true}
                                                                              employee_token_str={this.cookies.get("employee_token_str")}
                                                                              request={archiveDetail}
                                                                              optionInstalmentMode={optionInstalmentMode}
                                                                              optionComoany2={this.state.optionComoany2}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={9}></Grid>
                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button onClick={this.hidePaperDetail}>{"مخفی کردن"}</Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          </Collapse>
                                    </Grid>

                                    <Grid item xs={12}>
                                          {showPaperDetail ? (
                                                <Collapse in={showPaperDetail}>
                                                      <Container maxWidth="lg">
                                                            <RequestConcil request_id={archiveDetail["request_id"]} agent_id={0} />
                                                      </Container>
                                                </Collapse>
                                          ) : (
                                                ""
                                          )}
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ExcelFile
                                                            element={
                                                                  <Button variant="outlined" color="primary">
                                                                        {" "}
                                                                        {"اکسل "}
                                                                  </Button>
                                                            }
                                                      >
                                                            <ExcelSheet data={requestinfofilter} name="نمایندگان">
                                                                  <ExcelColumn label="آی دی سفارش" value="request_id" />
                                                                  <ExcelColumn label="شرکت" value="company_name" />
                                                                  <ExcelColumn label="رشته بیمه ای" value="request_fieldinsurance_fa" />
                                                                  <ExcelColumn label="توضیحات" value="request_description" />
                                                                  <ExcelColumn label="اخرین وضعیت" value="request_last_state_name" />
                                                                  <ExcelColumn label="نام کاربر" value="user_name" />
                                                                  <ExcelColumn label="نام خانوادگی کاربر" value="user_family" />
                                                                  <ExcelColumn label="همراه کاربر " value="user_mobile" />
                                                                  <ExcelColumn label="آی دی" value="agent_id" />
                                                                  <ExcelColumn label="جنسیت" value="agent_gender" />
                                                            </ExcelSheet>
                                                      </ExcelFile>

                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"request_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 30 }}
                                                                                    sortDirection={orderBy === "request_id" ? order : false}
                                                                              >
                                                                                    {" شماره سفارش"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_company_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_company_id"}
                                                                                          direction={orderBy === "request_company_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_company_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_fieldinsurance_fa"}
                                                                                          direction={
                                                                                                orderBy === "request_fieldinsurance_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_state_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"استان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_state_id"}
                                                                                          direction={orderBy === "agent_state_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_state_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_city_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شهر "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_city_id"}
                                                                                          direction={orderBy === "agent_city_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_city_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_mobile"}
                                                                                          direction={orderBy === "agent_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_last_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" وضعیت سفارش"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_last_state_name"}
                                                                                          direction={
                                                                                                orderBy === "request_last_state_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_last_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"staterequest_last_timestamp"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ آخرین وضعیت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "staterequest_last_timestamp"}
                                                                                          direction={
                                                                                                orderBy === "staterequest_last_timestamp"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("staterequest_last_timestamp")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    var varmoment = Moment(
                                                                                          row["staterequest_last_timestamp"],
                                                                                          "YYYY-M-D HH:mm:ss"
                                                                                    )
                                                                                    var date = new Date(parseInt(varmoment.format("x")))
                                                                                    var jdate1 = new JDate(date)
                                                                                    var dateMinStr =
                                                                                          jdate1.format("YYYY/MM/DD") +
                                                                                          "ساعت " +
                                                                                          varmoment.format("HH:mm")

                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["request_id"]}
                                                                                                value={row}
                                                                                                onClick={(e) => {
                                                                                                      this.handleSelectRows(e, row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"request_id"} align={"center"}>
                                                                                                      {row["request_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"request_company_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      <img
                                                                                                            alt=""
                                                                                                            style={{ height: "30px", width: "atuo" }}
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />

                                                                                                      {row["company_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"request_fieldinsurance_fa"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      <img
                                                                                                            alt=""
                                                                                                            style={{ height: "30px", width: "atuo" }}
                                                                                                            src={row["fieldinsurance_logo_url"]}
                                                                                                      />

                                                                                                      {row["request_fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_state_name"} align={"center"}>
                                                                                                      {row["agent_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_city_name"} align={"center"}>
                                                                                                      {row["agent_city_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_mobile"} align={"center"}>
                                                                                                      {row["agent_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"user_mobile"} align={"center"}>
                                                                                                      {row["user_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"request_last_state_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["request_last_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"staterequest_last_timestamp"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {dateMinStr}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000]}
                                                            component="div"
                                                            count={requestinfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

function PriceCard({
      addPriceCard,
      employee_token_str,
      request,
      optionInstalmentMode,
      PriceOffline,
      optionComoany2,
      newPriceCard = true,
      request_id,
}) {
      const [visible, setVisible] = useState(true)
      const [priceDetail, setPriceDetail] = useState({})
      const [instalment_condition, setInstalment_condition] = useState({})
      const [instalment_conditions, setInstalment_conditions] = useState([])
      const optionInstalmentDate = [
            { value: "0", label: "نقد" ,instalment_conditions_id:'70'},
            { value: "1", label: "یک ماه بعد" ,instalment_conditions_id:'71'},
            { value: "2", label: "دو ماه بعد" ,instalment_conditions_id:'72'},
            { value: "3", label: "سه ماه بعد" ,instalment_conditions_id:'73'},
            { value: "4", label: "چهار ماه بعد" ,instalment_conditions_id:'74'},
            { value: "5", label: "پنج ماه بعد" ,instalment_conditions_id:'75'},
            { value: "6", label: "شش ماه بعد" ,instalment_conditions_id:'76'},
            { value: "7", label: "هفت ماه بعد" ,instalment_conditions_id:'77'},
            { value: "8", label: "هشت ماه بعد" ,instalment_conditions_id:'78'},
            { value: "9", label: "نه ماه بعد" ,instalment_conditions_id:'79'},
            { value: "10", label: "ده ماه بعد" ,instalment_conditions_id:'80'},
            { value: "11", label: "یازده ماه بعد" ,instalment_conditions_id:'81'},
      ]
      useEffect(() => {
            if (PriceOffline) {
                  var arrPrice = []
                  try {
                        arrPrice = JSON.parse(PriceOffline.jsonpricing_text)
                        console.log(arrPrice)
                  } catch (e) {
                        console.error(e)
                  }
                  setPriceDetail(arrPrice)
                  setInstalment_conditions(arrPrice.instalment_conditions)
            }
      }, [])
      console.log(request)
      console.log(priceDetail)

      const deletePriceOfline = (v) => {
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              setVisible(false)
                        } else if (arr.result === "error") {
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_priceoffline")
            fd.append("jsonpricing_id", PriceOffline.jsonpricing_id)

            xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`)
            xhttp.setRequestHeader("Authorization", employee_token_str)
            xhttp.send(fd)
      }
      const modifyPriceOfline = (v) => {
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                        } else if (arr.result === "error") {
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_priceoffline")
            fd.append("jsonpricing_text", JSON.stringify(priceDetail))
            fd.append("jsonpricing_id", PriceOffline.jsonpricing_id)

            xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`)
            xhttp.setRequestHeader("Authorization", employee_token_str)
            xhttp.send(fd)
      }
      const addPriceOfline = (v) => {
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              addPriceCard()
                              setPriceDetail({})
                        } else if (arr.result === "error") {
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_requestoffline")
            fd.append("request_id", request.request_id)
            fd.append("fieldinsurance", request.fieldinsurance)
            fd.append("jsonpricing_text", JSON.stringify(priceDetail))

            xhttp.open("POST", `${constants.BASE_URL}/Employeerequestreport`)
            xhttp.setRequestHeader("Authorization", employee_token_str)
            xhttp.send(fd)
      }

      if (!visible) {
            return <></>
      } else
            return (
                  <Grid container spacing={3}>
                        <Grid item xs={6}>
                              <div>
                                    <label className="on">شرکت بیمه</label>
                                    <Select
                                          isSearchable={true}
                                          className="adapter-txtsize"
                                          placeholder={"شرکت بیمه"}
                                          value={optionComoany2.find((x) => x.value === priceDetail.company_id)}
                                          onChange={(e) => {
                                                setPriceDetail({
                                                      ...priceDetail,
                                                      company_id: e.value,
                                                      company_name: e.label,
                                                      company_logo_url: e.logo,
                                                })
                                          }}
                                          options={optionComoany2}
                                    />
                              </div>
                        </Grid>
                        <Grid item xs={6}>
                              <FloatingLabelInput
                                    placeholder="توضیحات کوتاه "
                                    handleInputt={(e) => {
                                          setPriceDetail({ ...priceDetail, tip: e.target.value })
                                    }}
                                    value={priceDetail.tip}
                              />
                        </Grid>
                        <Grid item xs={6}>
                              <FloatingLabelInput
                                    placeholder="توضیحات کامل "
                                    handleInputt={(e) => {
                                          setPriceDetail({ ...priceDetail, fieldcompany_desc: e.target.value })
                                    }}
                                    value={priceDetail.fieldcompany_desc}
                              />
                        </Grid>

                        <Grid item xs={6}>
                              <FloatingLabelInput
                                    placeholder=" قیمت "
                                    type="currency"
                                    handleInputt={(e) => {
                                          setPriceDetail({ ...priceDetail, price: e })
                                    }}
                                    value={priceDetail.price}
                              />
                        </Grid>
                        <Grid item xs={6}>
                              <FloatingLabelInput
                                    placeholder=" لینک رشته و شرکت "
                                    handleInputt={(e) => {
                                          setPriceDetail({ ...priceDetail, fieldcompany_link: e.target.value })
                                    }}
                                    value={priceDetail.fieldcompany_link}
                              />
                        </Grid>

                        <Grid item xs={6}>
                              <FloatingLabelInput
                                    placeholder=" توضیحات اقساظ "
                                    handleInputt={(e) => {
                                          setPriceDetail({ ...priceDetail, instalment_desc: e.target.value })
                                    }}
                                    value={priceDetail.instalment_desc}
                              />
                        </Grid>

                        <Grid item xs={12}>
                              {!priceDetail.instalment_conditions ? null : (
                                    <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                          {priceDetail.instalment_conditions.map((condition, index) => {
                                                return (
                                                      <PriceInstalmet
                                                            condition={condition}
                                                            changeInstallment={(e) => {
                                                                  var temp = priceDetail.instalment_conditions
                                                                  temp[index] = e
                                                                  setInstalment_conditions(instalment_conditions, temp)
                                                                  setPriceDetail({ ...priceDetail, instalment_conditions: temp })
                                                            }}
                                                            deleteInstallment={() => {
                                                                  var temp = priceDetail.instalment_conditions
                                                                  temp.splice(index, 1)
                                                                  setInstalment_conditions(instalment_conditions, temp)
                                                                  setPriceDetail({ ...priceDetail, instalment_conditions: temp })
                                                            }}
                                                            optionInstalmentMode={optionInstalmentMode}
                                                      />
                                                )
                                          })}
                                    </Grid>
                              )}
                              <Grid item xs={12}>
                                    <Grid container spacing={3}>
                                          <Grid item xs={6} sm={2}>
                                                <div>
                                                      <label className="on"> نوع</label>
                                                      <Select
                                                            isSearchable={true}
                                                            className="adapter-txtsize"
                                                            placeholder={"نوع اقساط"}
                                                            value={optionInstalmentMode.find(
                                                                  (x) => x.value === instalment_condition.instalment_conditions_mode_id
                                                            )}
                                                            onChange={(e) => {
                                                                  setInstalment_condition({
                                                                        ...instalment_condition,
                                                                        instalment_conditions_mode_id: e.value,
                                                                        instalment_mode_mode_name: e.label,
                                                                  })
                                                            }}
                                                            options={optionInstalmentMode}
                                                      />
                                                </div>
                                          </Grid>

                                          <Grid item xs={6} sm={3}>
                                                <div>
                                                      <label className="on"> زمان</label>
                                                      <Select
                                                            isSearchable={true}
                                                            className="adapter-txtsize"
                                                            placeholder={"زمان"}
                                                            value={optionInstalmentDate.find(
                                                                  (x) => x.value === instalment_condition.instalment_conditions_date
                                                            )}
                                                            onChange={(e) => {
                                                                  setInstalment_condition({
                                                                        ...instalment_condition,
                                                                        instalment_conditions_date: e.value,instalment_conditions_id:e.instalment_conditions_id
                                                                  })
                                                            }}
                                                            options={optionInstalmentDate}
                                                      />
                                                </div>
                                          </Grid>

                                          <Grid item item xs={2} sm={2}>
                                                <FloatingLabelInput
                                                      placeholder=" درصد "
                                                      type="percent"
                                                      handleInputt={(e) => {
                                                            setInstalment_condition({ ...instalment_condition, instalment_conditions_percent: e })
                                                      }}
                                                      value={instalment_condition.instalment_conditions_percent}
                                                />
                                          </Grid>
                                          <Grid item item xs={3} sm={2}>
                                                <FloatingLabelInput
                                                      placeholder=" مبلغ "
                                                      type="currency"
                                                      handleInputt={(e) => {
                                                            setInstalment_condition({ ...instalment_condition, instalment_conditions_amount: e })
                                                      }}
                                                      value={instalment_condition.instalment_conditions_amount}
                                                />
                                          </Grid>
                                          <Grid item item xs={3} sm={3}>
                                                <FloatingLabelInput
                                                      placeholder=" توضیحات "
                                                      handleInputt={(e) => {
                                                            setInstalment_condition({
                                                                  ...instalment_condition,
                                                                  instalment_conditions_desc: e.target.value,
                                                            })
                                                      }}
                                                      value={instalment_condition.instalment_conditions_desc}
                                                />
                                          </Grid>

                                          <Grid item item xs={4} sm={2}>
                                                <div style={{ width: "100%", textAlign: "left" }}>
                                                      <Fab
                                                            color="primary"
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                  setInstalment_conditions(instalment_conditions.concat(instalment_condition))
                                                                  setPriceDetail({
                                                                        ...priceDetail,
                                                                        instalment_conditions: instalment_conditions.concat(instalment_condition),
                                                                  })
                                                            }}
                                                      >
                                                            <AddIcon />
                                                      </Fab>
                                                </div>
                                          </Grid>
                                    </Grid>
                              </Grid>
                              <Grid>
                                    {newPriceCard ? (
                                          <Button
                                                onClick={() => {
                                                      console.log("dasdasdasd")
                                                      addPriceOfline()
                                                }}
                                                variant="contained"
                                                color="primary"
                                          >
                                                {" "}
                                                ثبت قیمت جدید
                                          </Button>
                                    ) : (
                                          <>
                                                <Button
                                                      variant="contained"
                                                      onClick={() => {
                                                            console.log("dasdasdasd")
                                                            modifyPriceOfline()
                                                      }}
                                                      color="primary"
                                                >
                                                      {" "}
                                                      تغییر
                                                </Button>

                                                <Button
                                                      onClick={() => {
                                                            console.log("dasdasdasd")
                                                            deletePriceOfline()
                                                      }}
                                                      variant="contained"
                                                      color="secondary"
                                                >
                                                      {" "}
                                                      حذف
                                                </Button>
                                          </>
                                    )}
                              </Grid>
                        </Grid>
                  </Grid>
            )
}

function PriceInstalmet({ condition, optionInstalmentMode, changeInstallment, deleteInstallment }) {
      const [condition1, setCondition1] = useState(condition)
      const optionInstalmentDate = [
            { value: "0", label: "نقد" ,instalment_conditions_id:'70'},
            { value: "1", label: "یک ماه بعد" ,instalment_conditions_id:'71'},
            { value: "2", label: "دو ماه بعد" ,instalment_conditions_id:'72'},
            { value: "3", label: "سه ماه بعد" ,instalment_conditions_id:'73'},
            { value: "4", label: "چهار ماه بعد" ,instalment_conditions_id:'74'},
            { value: "5", label: "پنج ماه بعد" ,instalment_conditions_id:'75'},
            { value: "6", label: "شش ماه بعد" ,instalment_conditions_id:'76'},
            { value: "7", label: "هفت ماه بعد" ,instalment_conditions_id:'77'},
            { value: "8", label: "هشت ماه بعد" ,instalment_conditions_id:'78'},
            { value: "9", label: "نه ماه بعد" ,instalment_conditions_id:'79'},
            { value: "10", label: "ده ماه بعد" ,instalment_conditions_id:'80'},
            { value: "11", label: "یازده ماه بعد" ,instalment_conditions_id:'81'},
      ]

      useEffect(() => {
            changeInstallment(condition1)
      }, [condition1])

      return (
            <Grid item xs={12}>
                  <Grid container spacing={3}>
                        <Grid item xs={6} sm={2}>
                              <div>
                                    <label className="on"> نوع</label>
                                    <Select
                                          isSearchable={true}
                                          className="adapter-txtsize"
                                          placeholder={"نوع اقساط"}
                                          value={optionInstalmentMode.find((x) => x.value === condition1.instalment_conditions_mode_id)}
                                          onChange={(e) => {
                                                setCondition1({
                                                      ...condition1,
                                                      instalment_conditions_mode_id: e.value,
                                                      instalment_mode_mode_name: e.label,
                                                })
                                          }}
                                          options={optionInstalmentMode}
                                    />
                              </div>
                        </Grid>

                        <Grid item xs={6} sm={3}>
                              <div>
                                    <label className="on"> زمان</label>
                                    <Select
                                          isSearchable={true}
                                          className="adapter-txtsize"
                                          placeholder={"زمان"}
                                          value={optionInstalmentDate.find((x) => x.value === condition1.instalment_conditions_date)}
                                          onChange={(e) => {
                                                setCondition1({ ...condition1,
                                                      instalment_conditions_date: e.value,instalment_conditions_id:e.instalment_conditions_id

                                                })
                                          }}
                                          options={optionInstalmentDate}
                                    />
                              </div>
                        </Grid>

                        <Grid item item xs={2} sm={2}>
                              <FloatingLabelInput
                                    placeholder=" درصد "
                                    type="percent"
                                    handleInputt={(e) => {
                                          setCondition1({ ...condition1, instalment_conditions_percent: e })
                                    }}
                                    value={condition1.instalment_conditions_percent}
                              />
                        </Grid>
                        <Grid item item xs={3} sm={2}>
                              <FloatingLabelInput
                                    placeholder=" مبلغ "
                                    type="currency"
                                    handleInputt={(e) => {
                                          setCondition1({ ...condition1, instalment_conditions_amount: e })
                                    }}
                                    value={condition1.instalment_conditions_amount}
                              />
                        </Grid>
                        <Grid item item xs={3} sm={3}>
                              <FloatingLabelInput
                                    placeholder=" توضیحات "
                                    handleInputt={(e) => {
                                          setCondition1({ ...condition1, instalment_conditions_desc: e.target.value })
                                    }}
                                    value={condition1.instalment_conditions_desc}
                              />
                        </Grid>

                        <Grid item item xs={4} sm={2}>
                              <div style={{ width: "100%", textAlign: "left" }}>
                                    <Fab
                                          color="secondary"
                                          aria-label="edit"
                                          onClick={() => {
                                                deleteInstallment()
                                          }}
                                    >
                                          <DeleteIcon />
                                    </Fab>
                              </div>
                        </Grid>
                  </Grid>
            </Grid>
      )
}

export default withStyles(styles)(ArchiveOrdersNotPay)
